<template>
  <div class="wrap">
    <div class="profile profile-1 flex flex-vc">
      <div class="avatar">
        <img
          :src="userInfo.avatar ? userInfo.avatar : defaultAvatar"
          @click="(_) => (this.show = !this.show)"
        />
        <van-image-preview
          v-model="show"
          :images="[userInfo.avatar]"
          v-show="userInfo.avatar"
        />
      </div>
      <div class="info flex-1">
        <div class="name">
          <div>{{ userInfo.name }}</div>
        </div>
        <div class="phone flex flex-vc" >
          <div style="min-width: 52px">手机号：</div>
          <div v-if="!isEdit">
            {{ userInfo.mobile }}
          </div>
          <input
            class="phoneIpt"
            v-else
            ref="tt"
            autofocus
            v-model="userInfo.mobile"
            @blur="changeMsg"
          />
          <span v-if="errmsg" class="errmsg">手机号格式有误</span>
        </div>
      </div>
      <div>
        <!-- <van-icon :name="iconName" @click="iconChange(isEdit)" /> -->
        <el-button
          size="medium"
          :type="btnValue == '保存' ? 'primary' : ''"
          style="
            transform: scale(0.7);
            font-size: 1.5rem;
            padding: 0.5rem 0.8rem;
          "
          @click="iconChange(isEdit)"
          >{{ btnValue }}</el-button
        >
<!-- 点击跳转小程序获取手机号 -->
    <!-- <wx-open-launch-weapp
      id="launch-btn"
      v-if="!userInfo.mobile"
      username="gh_8c94a88bf20e"
      :path="path"
      @launch="onLaunch"
      @error="onError"
    >
      <script type="text/wxtag-template">
        <style>
          .btn {
            background-color: #409EFF;
            color: #fff;
            border: none;
            text-align: center;
            font-size: 16px;
            padding: 3px 8px;
            border-radius: 3px;
            margin-right: 10px;
            borer-style:none;
          }
        </style>
        <button class="btn" @click="test">绑定</button>
      </script>
    </wx-open-launch-weapp> -->

      </div>
    </div>

    <div
      class="profile profile-2"
      v-for="item in classList"
      :key="item.schoolId"
    >
      <div class="title">{{ item.schoolName }}</div>
      <div class="list-info">
        <div class="item flex flex-b flex-vc">
          <div class="left flex flex-vc">
            <img src="@/assets/images/m10.png" alt="" />
            <span>所在部门</span>
          </div>
          <div class="right">{{ item.deptName }}</div>
        </div>
        <div class="item flex flex-b flex-vc">
          <div class="left flex flex-vc">
            <img src="@/assets/images/m9.png" alt="" />
            <span>管理班级</span>
          </div>
          <div class="right">
            <span v-for="classes in item.classList" :key="classes.classId">{{
              classes.className
            }}</span>
            <span v-if="!item.classList">暂无</span>
          </div>
        </div>
      </div>
    </div>
    <div class="profile profile-3" v-if="vipData.length">
      <div class="title">孩子信息</div>
      <div class="child-list">
        <div v-for="item in vipData" class="item flex" :key="item.id">
          <div class="i-1">
            <span>{{ item.name }}</span>
            <img :src="imgIcon[item.status]" alt="" />
          </div>
          <div class="i-2 flex-1">
            <div class="i-2-top">
              <span>{{ item.schoolName }}</span>
              <span>{{ item.className }}</span>
            </div>
            <div class="i-2-bottom not" @click="hrefVip(item)">
              {{
                item.status == 1
                  ? "未订阅"
                  : item.status == 0 && item.type == 0
                  ? "消息订阅到期时间：" + VipTime(item.expireDate)
                  : item.status == 0 && item.type == 1
                  ? "消息订阅已开通"
                  : item.status == 2 && item.type == 0
                  ? "视频订阅到期时间：" + VipTime(item.expireDate)
                  : item.status == 2 && item.type == 1
                  ? "视频订阅已开通"
                  : ""
              }}
              <span>&gt;</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import imgTrue from "@/assets/images/m12.png";
import imgFalse from "@/assets/images/m11.png";
import avatar from "@/assets/images/avatar方.png";
import moment from "moment";
import { Dialog } from "vant";
import store from "@/store";
// import Share from "@/utils/wsSDK";
export default {
  data() {
    return {
      defaultAvatar: avatar,
      isEdit: false,
      show: false,
      // iconName: "edit",
      btnValue: "编辑",
      userInfo: {},
      classList: [],
      vipData: [],
      imgIcon: [imgTrue, imgFalse, imgTrue],
      phoneChanged: false,
      errmsg: false,
      personType: "",
      // 页面授权路径
      path: null,
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  created () {
  //  location.reload()
  },
  async mounted() {
    this.initWXConfig();

    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // console.log(this.userInfo);
    if (!this.userInfo.mobile || this.userInfo.mobile === "") {
      this.isEdit = true;
      this.btnValue = "保存";
      Dialog.alert({
        title: "温馨提示",
        message: "请点击绑定按钮,进行身份绑定",
      }).then(() => {
        this.$nextTick(() => {
          this.$refs.tt.focus();
        });
      });
    }
    this.getClassInfo();
    this.getVipData();
  },
  watch: {
    "userInfo.mobile": function (value) {
      this.phoneChanged =
        value != JSON.parse(localStorage.getItem("userInfo")).mobile;
    },
  },
  created() {
    // this.getUserInfo()
  },
  computed: {},
  methods: {
    test() {
      console.log('1234')
      wx.closeWindow()
    },
    onLaunch() {
      
      console.log("onLaunch");
      wx.closeWindow()
    },
    onError() {
      console.log("Error");
    },
    async getSchoolList() {
      const { code, data } = await this.$https.getSchoolList({
        // userId: this.$store.state.userId,
      });
      // console.log("信息", data);
      if (code !== 200) {
        this.list = [];
        return false;
      }
      let obj = {
        13: "老师",
        12: "家长",
        2: "访客",
      };
      if (data.patriarchList.length + data.teacherList.length === 1) {
        if (data.patriarchList.length > 0) {
          this.personType = 12;
          // console.log('我是家长开始进入选择角色了');
          this.identitySwitch(data.patriarchList[0].id);
        } else if (data.teacherList.length > 0) {
          this.personType = 13;
          // console.log('我是老师开始进入选择角色了');
          this.identitySwitch(data.teacherList[0].id);
        } else {
          this.personType = "访客";
        }
      } else {
        setTimeout(() => {
          this.$router.push({
            name: "schoolList",
            params: { hrefTo: true },
          });
        }, 500);
      }
    },
    // getUserInfo(code) {
    //   return axios.post("auth/api/autoLogin", {
    //     code,
    //     appId: store.state.appId,
    //   });
    // },

    // 微信开放标签跳转
    initWXConfig() {
      // 获取开放标签配置信息
      this.$https
        .getWXConfig({
          appid: store.state.appId,
          url: location.href.split("#")[0],
        })
        .then((res) => {
          // 跳转小程序相关配置
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp, //生成签名的时间戳
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ["onMenuShareWeibo","closeWindow"],
            openTagList: ["wx-open-launch-weapp"],
          });
        });

      wx.ready(function () {
        // wx.closeWindow()
      });
      wx.error(function (res) {
        console.log("配置失败", res);
      });
      // 配置标签跳转路径
      let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
      let openId = JSON.parse(localStorage.getItem("userInfo")).openId;
      let token = localStorage.getItem("token");
      this.path = `pages/authPhone/indelx/indelx?loginId=${loginId}&openId=${openId}&token=${token}`;
    },
    // 身份切换
    async identitySwitch(id) {
      const { data, code } = await this.$https.identitySwitch({
        openId: JSON.parse(localStorage.getItem("userInfo")).openId,
        userId: id,
        userType: this.personType == 13 ? "1" : "2",
      });
      // return
      if (code !== 200) {
        return;
      }
      // console.log('选中角色了，重新执行查询');
      // console.log(data);
      this.$store.commit("setUserId", data.id);
      this.$store.commit("setSchoolId", data.schoolId);
      localStorage.setItem("userInfo", JSON.stringify(data));
      this.getClassInfo();
      this.getVipData();
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    },
    changeMsg() {
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

      this.errmsg = userInfo.mobile != "" && !reg.test(this.userInfo.mobile);
    },
    VipTime(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    hrefVip(value) {
      // console.log(value);
      this.$router.push({
        name: "openvip",
        params: value,
      });
    },
    iconChange(type) {
      if (!type) {
        this.isEdit = !type;
        // this.iconName = type ? "edit" : "passed";、
        this.btnValue = type ? "编辑" : "保存";
        this.$nextTick(() => {
          this.$refs.tt.focus();
        });
      } else {
        //格式进来进入保存
        if (!this.errmsg) {
          this.isEdit = !type;
          // this.iconName = type ? "edit" : "passed";
          this.btnValue = type ? "编辑" : "保存";
          let userInfo = { ...this.userInfo };
          delete userInfo.idNumber;
          this.axios
            .post("student-consumer/api/user/updateTpdUser", userInfo)
            .then((res) => {
              if (res.code === 200) {
                if (res.data) {
                  let info = JSON.parse(localStorage.getItem("userInfo"));
                  localStorage.setItem(
                    "userInfo",
                    JSON.stringify({
                      ...info,
                      ...res.data,
                    })
                  );
                }
                this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
                if (this.phoneChanged) {
                  this.$toast("保存成功，请进行身份切换");
                  this.getSchoolList();
                  setTimeout(() => {
                    this.$router.push({
                      name: "schoolList",
                      params: { hrefTo: true },
                    });
                  },500)
                }
              } else {
                this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$toast("服务器错误，请联系管理员");
            });
        }
      }
    },
    async getClassInfo() {
      this.axios
        .get("student-consumer/api/user/getTeacherByPhone", {
          params: {
            mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.classList = res.data;
          } else {
            this.$toast("服务器错误，请联系管理员");
          }
        });
    },
    async getVipData() {
      const { code, data } = await this.$https.getParentsPayAuthChildrenList({
        mobile: JSON.parse(localStorage.getItem("userInfo")).mobile,
      });
      if (code !== 200 || !data) {
        return;
      }
      this.$store.commit("setVipData", data);
      this.childRadio = data[0].id;
      this.vipData = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 15px;
  .profile {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 15px;
    color: #1a1a1a;
  }
}
.profile-1 {
  padding: 10px;
  padding-right: 0px;
  position: relative;
  .avatar {
    width: 73px;
    height: 73px;
    margin-right: 17px;
    border-radius: 8px;
    overflow: hidden;
  }
  .info {
    position: relative;
    // margin-right: 20px;
    .name {
      margin-bottom: 8px;
      color: #1a1a1a;
      font-size: 16px;
    }
    .phone {
      font-size: 16px;
      color: #666;
      div {
        height: 16px;
        line-height: 16px;
      }
    }
  }
  // .icon {
  //   position: absolute;
  //   right: 45px;
  //   width: 17px;
  //   height: 17px;
  //   top: 18px;
  // }
  .input {
    border: none;
  }
  // .ninput {
  //   line-height: 21px;
  // }
}
.profile-2 {
  img {
    width: 15px;
    height: 15px;
    margin-right: 13px;
  }
  .list-info {
    .item {
      padding: 8px 15px;
      font-size: 13px;
      .left {
        color: #666666;
      }
      .right {
        width: 65%;
        display: flex;
        flex-wrap: wrap;
        span {
          margin-right: 8px;
        }
      }
    }
  }
}
.profile-3 {
  .child-list {
    .item {
      padding: 5px 23px 10px 23px;
      /* margin: 10px 0; */
      font-size: 13px;
      .i-1 {
        margin-right: 12px;
        width: 25%;
        display: flex;
        span {
          height: 15px;
          display: inline-block;
        }
        img {
          width: 14px;
          height: 14px;
          margin-left: 6px;
          margin-top: 1px;
          float: right;
        }
      }
      .i-2 {
        span:first-child {
          margin-right: 10px;
        }
        .i-2-bottom {
          font-size: 12px;
          margin-top: 6px;
          color: #666666;
          span {
            margin-left: 5px;
          }
        }
      }
    }
  }
}
.title {
  padding: 12px 25px;
  position: relative;
  font-size: 15px;
  color: #1a1a1a;

  &::before {
    content: "";
    position: absolute;
    left: 15px;
    height: 13px;
    width: 3px;
    background: #37a5da;
    top: 16px;
  }
}
img {
  width: 100%;
  height: 100%;
}
.phoneIpt {
  padding: 0;
  font-size: 16px;
  width: 6.375rem;
  outline: none;
  border: none;
  height: 16px;
  line-height: 18px;
}
.errmsg {
  position: absolute;
  bottom: -15px;
  left: 45px;
  color: red;
  font-size: 12px;
  transform: scale(0.8);
}
</style>
